export default class ErrorsAndOmissions {

	public carrierName: string | null = null;
	public policyNumber: string | null = null;
	public limitPerClaim: number | null = null;
	public aggregateLimit: number | null = null;
	public policyExpirationDate: Date | null = null;

	public constructor() {

	}
};
